import { PropsWithChildren, FC, useCallback, useRef, useState } from 'react'
import { Col, Row, Spin } from 'antd'
import { PlusOutlined, PauseOutlined } from '@ant-design/icons'
import Card from '@/pages/Tbqy/components/components/Card'
import CardContainer from '@/pages/Bmjy/components/components/CardContainer'
import styles from '../../style.module.less'

const tabsOptions = [
  {
    label: '按公司',
    value: 'ags',
    api: null
  }, 
  {
    label: '按院', 
    value: 'ay',
    api: null
  }, 
  {
    label: '按所', 
    value: 'as',
    api: null
  }
]

type PropType = FC<PropsWithChildren<{
  updateTime: string
}>>

const Component: PropType = ({updateTime}) => {
  const [loading, setLoading] = useState(false)
  const globalRef = useRef({
    params: {
      tab: '',
      depart: ''
    },
    loadTime: updateTime
  })

  const getData = useCallback(async() => {

  }, [])

  // 变更类型
  const handleTabChange = useCallback((value) => {
    globalRef.current.params = value
    getData()
  }, [getData])

  return (
    <Spin spinning={loading} >
      <Card title="进行中数据统计" hasExport={false}>
        <CardContainer
          tabs={tabsOptions}
          onTabChange={handleTabChange}
          hasExport={false}
          hasDepartSelect
        >
          <div className='mt-30 mlr-10'>
            <Row>
              <Col span={2}>
                <div className={`${styles['item-tag']} font-16 pt-4`}>进行中工作</div>
              </Col>
              <Col span={4}>
                <div >
                  <div className='text-999'>进行中合同</div>
                  <div>
                    <span className={`text-primary font-28 font-700`}>27</span>
                    <span className='font-12 ml-6'>个</span>
                  </div>
                </div>
              </Col>
              <Col span={2}>
                <div className='flex justify-center'>
                  <div className='border-left border-right ' style={{height: '70px'}}></div>
                </div>
              </Col>
              <Col span={4}>
                <div className='ml-20'>
                  <div className='text-999'>未完成委托单</div>
                  <div>
                    <span className={`text-primary font-28 font-700`}>27</span>
                    <span className='font-12 ml-6'>份</span>
                  </div>
                </div>
              </Col>
              <Col span={11}>
                <div >
                  <div className='text-999'>总价值</div>
                  <div>
                    <span className={`font-28 font-700`}>6,659.15</span>
                    <span className='font-12 ml-6'>元</span>
                  </div>
                </div>
              </Col>
            </Row>
            <Row className='mt-20 mb-10'>
              <Col span={2}>
                <div className={`${styles['item-tag']} ${styles['item-tag-green']} font-16 pt-4`}>未确认收入</div>
              </Col>
              <Col span={4}>
                <div >
                  <div className='text-999'>未确认收入合计</div>
                  <div>
                    <span className={`text-primary font-28 font-700`}>5,693.27</span>
                    <span className='font-12 ml-6'>元</span>
                  </div>
                </div>
              </Col>
              <Col span={2}>
                <div className={`${styles['item-equal']} flex align-center justify-center h-full`}>
                  <PauseOutlined />
                </div>
              </Col>
              <Col span={4}>
                <div className='ml-20'>
                  <div className='text-999'>未结算报告</div>
                  <div>
                    <span className={`font-28 font-700`}>27</span>
                    <span className='font-12 ml-6'>份</span>
                  </div>
                </div>
              </Col>
              <Col span={3}>
                <div >
                  <div className='text-999'>总价值</div>
                  <div>
                    <span className={`${styles['green-item']} font-28 font-700`}>5,693.27</span>
                    <span className='font-12 ml-6'>元</span>
                  </div>
                </div>
              </Col>
              <Col span={2}>
                <div className={`${styles['item-equal']} flex align-center justify-center h-full`}>
                  <PlusOutlined />
                </div>
              </Col>
              <Col span={3}>
                <div >
                  <div className='text-999'>待开票结算单</div>
                  <div>
                    <span className={`font-28 font-700`}>36</span>
                    <span className='font-12 ml-6'>份</span>
                  </div>
                </div>
              </Col>
              <Col span={4}>
                <div >
                  <div className='text-999'>总价值</div>
                  <div>
                    <span className={`${styles['green-item']} text-primary font-28 font-700`}>4,993.38</span>
                    <span className='font-12 ml-6'>元</span>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </CardContainer>
      </Card>
    </Spin>
  )
}

export default Component
